import axios from 'axios'
import MockAdapter from 'axios-mock-adapter'
import {base_url} from '../_common'
import {buildIndex, mockRequests} from './_utils'
import {ResponseError} from './_response'
import middlewares from './_middlewares'
import {increase_counter, registered_sections} from './updates'

// =============================================================
// mock axios requests

const path = `${base_url}/people`;
let mockAdapter;

export function register_mock() {
  registered_sections['test'] = true;
  mockAdapter = new MockAdapter(axios);

  mockRequests({
    mockAdapter,
    delay: 500,
    middlewares: middlewares.logs,
    requests: [
      ['get', path, () => index()],
      ['get', path+'/:id', ({route}) => show(route.id)],
      ['post', path, ({data}) => store(data.person)],
      ['put', path+'/:id', ({data}) => update(data.person)],
      ['delete', path+'/:id', ({route}) => destroy(route.id)],
    ]
  });

  // pass through other requests
  mockAdapter.onAny().passThrough();
}

// =============================================================
// data

const people = [
  {
    id: 1,
    name: 'Mohamed',
    age: 28,
  },
  {
    id: 2,
    name: 'Ahmed',
    age: 18,
  },
  {
    id: 3,
    name: 'Ali',
    age: 35,
  },
];


let people_id = (people[people.length -1] || {id: 0}).id;
const new_id = () => ++people_id;

let inx;

// =============================================================
// controller helper methods

function rebuild(counters = true) {
  inx = buildIndex(people);
  counters && increase_counter('test');
}
rebuild(false);

// =============================================================
// controller CRUD methods

export function index() {
  return {people};
}

export function show(id) {
  return {person: people[inx[id]]};
}

export function store(person) {
  person.id = new_id();

  // validation example
  if (!person.name) {
    throw new ResponseError(422, {name: ['required']});
  }

  people.push(person);
  rebuild();
  return {id: person.id};
}

export function update(person) {
  if (inx[person.id] === undefined) {
    throw new ResponseError(404, {_: ['not_found@Person']});
  }

  people.splice(inx[person.id], 1, person);
  rebuild();
}

export function destroy(id) {
  
  if (inx[id] === undefined) {
    throw new ResponseError(404, {_: ['not_found@Person']});
  }

  people.splice(inx[id], 1);
  rebuild();
}
